import { toError } from "@clipboard-health/util-ts";

import { routes, SESSION_HOME_ROUTE_PATHS } from "@src/appV2/redesign/utils/routes";
import { APP_V2_APP_EVENTS, logError } from "@src/appV2/lib/analytics";
import { Platform } from "@src/mobile/utils/platform";

import { addAppBackButtonListener, exitApp } from "./app.adapter";

const EXIT_PATHS = new Set<string>([
  routes.root,
  routes.enter,
  routes.login,
  ...SESSION_HOME_ROUTE_PATHS,
]);

function isExitPath(pathname: string): boolean {
  const normalizedPathname = pathname.replace(/\/+$/, "") || routes.root;
  return EXIT_PATHS.has(normalizedPathname);
}

function logBackButtonFailure(error: unknown): void {
  logError(APP_V2_APP_EVENTS.ANDROID_BACK_BUTTON_FAILURE, {
    error: toError(error),
  });
}

/**
 * Overrides Capacitor's Android back-button behavior so landing routes close
 * the app while deeper routes continue through the browser history stack.
 */
export async function initializeAndroidBackButton(): Promise<void> {
  if (!Platform.isAndroid) {
    return;
  }

  try {
    await addAppBackButtonListener(({ canGoBack }) => {
      if (isExitPath(window.location.pathname) || !canGoBack) {
        void exitApp().catch(logBackButtonFailure);
        return;
      }

      window.history.back();
    });
  } catch (error: unknown) {
    logBackButtonFailure(error);
  }
}
